import React, { useState } from 'react';
import {
  Text, Spacer, IconComponent, ThumbsDown, ThumbsUp,
} from '@myinterview/component-library';
import { useTranslation } from 'react-i18next';
import { GAevent } from '../utils/googleAnalytics';
import { updateSession } from '../services/sessionService';
import { emitTrackEvent, EVENT_TYPES } from '../services/eventService';

export const TopTips = () => {
  const { t } = useTranslation();
  const [clicked, setClicked] = useState('');
  const handleClick = (e:string) => {
    GAevent(`tips_thumbs_${e}`);
    emitTrackEvent({ eventType: e === 'up' ? EVENT_TYPES.TOP_TIPS_LIKED : EVENT_TYPES.TOP_TIPS_DISLIKED });
    updateSession({
      top_tips_clicked: new Date(),
      top_tips_positive_rating: e === 'up',
    }).then(() => {

    });
    setClicked(e);
  };
  return (
    <>
      <Text size="L-Regular">{t('top_tips.title')}</Text>
      <Spacer y={1} />
      <ul className="toptips__modal__list">
        <li><Text size="S-Regular">{t('top_tips.tip_1')}</Text></li>
        <li><Text size="S-Regular">{t('top_tips.tip_2')}</Text></li>
        <li><Text size="S-Regular">{t('top_tips.tip_3')}</Text></li>
        <li><Text size="S-Regular">{t('top_tips.tip_4')}</Text></li>
        <li><Text size="S-Regular">{t('top_tips.tip_5')}</Text></li>
        <li><Text size="S-Regular">{t('top_tips.tip_6')}</Text></li>
      </ul>
      <div>{t('top_tips.tip_7')}</div>
      <Spacer y={1} />
      <div className="toptips__modal__line" />
      <Spacer y={1} />
      <Text className="toptips__modal__survey__title" color="neutral-60" size="S-Regular">{t('top_tips.survey')}</Text>
      <Spacer y={1} />
      <div className="toptips__modal__survey__icons ignore-direction">
        <div className={`toptips__modal__survey__icons__icon${clicked === 'down' ? '--notClicked' : ''}`}>
          <IconComponent onClick={() => handleClick('up')} size="30px" icon={<ThumbsUp />} />
        </div>
        <Spacer x={1} />
        <div className={`toptips__modal__survey__icons__icon${clicked === 'up' ? '--notClicked' : ''}`}>
          <IconComponent onClick={() => handleClick('down')} size="30px" icon={<ThumbsDown />} />
        </div>
      </div>
    </>
  );
};
